import { Group, Title, Button, TooltipFloating } from '@mantine/core';
import { IconGridDots, IconInfoCircle } from '@tabler/icons-react';
import React from 'react';
import DataTable from 'react-data-table-component';
import useGetMatch from './useMatchOffer';
import LoadingErrorContainer from '../../../components/placeholders/LoadingErrorContainer';
import UserRow from './components/UserRow';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useNavigate } from "react-router-dom";
import ActionCell from './components/ActionCell';


dayjs.extend(utc);
dayjs.extend(timezone);


const Remote = () => {
    const navigate = useNavigate();
    const { MatchQuery: {
        data, isPending, isError, isRefetching },
        totalRows,
        handleChangePerPage,
        handlePageChange,
        search,
        setSearch
    } = useGetMatch()


    const columns = [

        {
            name: 'User Name',
            selector: row => row.user.tiktok_username,
            //sortable: true,
            cell: row => <UserRow row={row.user} />,
            width: "200px",
        },


        {
            name: 'Match Style',
            selector: row => row.match_style ? row.match_style?.name : 'N/A',
            // sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            // sortable: true,
        },
        // {
        //     name: 'Country',
        //     selector: row => row.country ? row.country : 'N/A',
        //     // sortable: true,
        // },
        {
            name: 'Language',
            selector: row => row.language ? row.language : 'N/A',
            // sortable: true,
        },

        {
            name: 'Start Date and Time',
            selector: row => {
                // Parse the UTC time and convert to local time
                const localTime = dayjs.utc(row.start_time).local().format('D MMM YY, HH:mm');
                return localTime;
            },
            sortable: true,
            width: "150px",
        },
        {
            name: 'End Date and Time',
            selector: row => {
                // Parse the UTC time and convert to local time
                const localTime = dayjs.utc(row.end_time).local().format('D MMM YY, HH:mm');
                return localTime;
            },
            sortable: true,
            width: "150px",
        },
        {
            name: 'Opponent Name',
            selector: row => row.opponent ? row.opponent.tiktok_username : 'N/A',
            //sortable: true,
            cell: row => row.opponent ? <UserRow row={row.opponent} /> : 'N/A',
            width: "200px",
        },
        {
            name: 'Action',
            //sortable: true,
            cell: row => row.status == 'confirmed' ? <ActionCell row={row} /> : 'N/A',
            width: "200px",
        },

    ];

    const handleClick = () => {
        navigate('create'); // Adjust the path according to your routing setup
    };



    return (
        <LoadingErrorContainer isError={isError} isLoading={isPending} isRefetching={isRefetching}>
            <Group justify='space-between'>
                <Group>
                    <Title order={3}>Match Offers</Title>

                    <a target='_blank' href="https://famelive-edu.eu/en/support-agents
"><TooltipFloating label="Information"><IconInfoCircle /></TooltipFloating></a></Group >
                <Button
                    variant="gradient"
                    gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                    onClick={handleClick}
                    leftSection={<IconGridDots style={{ width: '1rem', height: '1rem', alignSelf: "flex-end" }} />}

                >Create  match offers </Button>

            </Group>
            <DataTable
                columns={columns}
                data={data?.data ?? []}
                progressPending={isPending}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handleChangePerPage}
                onChangePage={handlePageChange}



            // selectableRows

            />

        </LoadingErrorContainer>


    );

}

export default Remote;
